import baseConfigs from './base';
import devConfigs from './dev';
import prodConfigs from './prod';

let configs = devConfigs;

const env = process.env.REACT_APP_CONFIG || process.env.NODE_ENV;
console.log('env', process.env.REACT_APP_CONFIG, process.env.NODE_ENV);
if (env === 'production') {
  configs = prodConfigs;
}

configs = Object.assign({}, baseConfigs, configs);

Object.assign(configs, {
  tokenUrl: `${configs.authServiceUrl}/token`,
  authorizationUrl: `${configs.authServiceUrl}/dialog/oauth`,
  logoutUrl: `${configs.authServiceUrl}/logout`,

  userProfileUrl: `${configs.authApiUrl}/me/profile`,
  spaceTokenUrl: `${configs.authApiUrl}/space-token`,
  listSpacesUrl: `${configs.authApiUrl}/me/spaces`,
  spaceUsersUrl: `${configs.authApiUrl}/me/current-space/users`,

});

export default Object.freeze(configs);



// WEBPACK FOOTER //
// ./src/configs/index.js